<template>

</template>

<script>
import Api from "../models/Api";
import {eventBus} from "../main";
import { loadScript } from "vue-plugin-load-script";
import UserModel from "../models/UserModel";

export default {
  name: "RedirectTelegram",
  mounted() {
    var app=this;
    var query={};
    if(app.$route.query.rand_code){
      query.rand_code=app.$route.query.rand_code;
    }
    var url_to_route=app.$route.query.redirect_inner;
    var user=UserModel.get();
    console.log('current user');
    console.log(user);
    if(user){
      app.$router.push({path: url_to_route,query: query});
    }












    // the function receives the target route as the argument
    // we return a redirect path/location here.
   // return { path: to.query.redirect_inner, query: query }
  }
}
</script>

<style scoped>

</style>